import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=d14102d2&scoped=true&"
import script from "./Issues.vue?vue&type=script&lang=js&"
export * from "./Issues.vue?vue&type=script&lang=js&"
import style0 from "./Issues.vue?vue&type=style&index=0&id=d14102d2&prod&lang=scss&"
import style1 from "./Issues.vue?vue&type=style&index=1&id=d14102d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14102d2",
  null
  
)

export default component.exports